export default "__VITE_ASSET__d3a741c4__"